import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  private readonly translate = inject(TranslateService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const changedReq = req.clone({
      headers: req.headers.set('Accept-Language', this.translate.getCurrentLang()),
    });
    return next.handle(changedReq);
  }
}
